:host {
  display: inline-block;
}

.share-button {
  background: none;
  border: none;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.share-text {
  color: var(--cms-black);
}

.social-share-anchor {
  display: none;
}

.svg-wrapper {
  margin-right: 0.25rem;
}

@include media-width($breakpoint-md) {
  .social-share-anchor {
    display: block;
  }

  .share-button {
    display: none;
  }
}
